import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '../../../../../config/config';
import { VisitorTripCommand } from '../../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../../../../commands/visitor/all.frontend.settings.command';
import { ButtonTriggerEvent, MatFieldComponent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { FacebookLoginButtonComponent } from '../../../../common/components/facebook.login.button/facebook.login.button.component';
import { FacebookPost } from '../../../../common/components/facebook.post/facebook.post';
import { HubPlaceAdditionalData } from '../../../../models/hub/hub.google.place.data';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { EventTimeService } from '../../../../services/event.time.service';
import { ImageService } from '../../../../services/image.service';
import { PlaceService } from '../../../../services/place.service';
import { ShareService } from '../../../../services/share.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import {
  AllFrontendSettingsStore,
  VisitorTripNotifyAddOrRemoveItemStore,
  VisitorTripStore,
} from '../../../../stores/visitor.calendar.store';
import { ImageComponent } from '../../../../common/components/image/image.component';

@Component({
  selector: 'ig-trip-float-detail',
  templateUrl: './trip.float.detail.component.html',
  styleUrls: ['./trip.float.detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TripFloatDetailComponent extends BaseComponent implements OnInit {
  public hubName: string;
  public urlTripId: string;
  public urlTripFromUserID: string;
  public item: any;
  public type: string;
  public placeSource = 'google';
  public googleInfo: HubPlaceAdditionalData | null;
  @Input() showOperation = false;
  @Input() showAddToTrip = false;
  public isShowDetail = false;
  public isInAnyTrip = false;
  public detailDate = null;
  public detailTime = null;
  public isMultiDateEvent = false;
  public placeFeeds: FacebookPost[];
  public placeFeedPaging: { next: string };
  public isFeedLoaded = false;
  public isShowNearbyPlaces = false;
  public canShowGoogleReviews = false;
  public isShowFeedForMobile = false;
  public trancatedEventTimes = [];
  public trancatedEventTimesText = [];
  public userID = null;
  public facebookLogo = config.facebook.logo;
  public featuresToggle = new HubVisitorFeatureToggle();
  @ViewChild('menuTrigger') public menuTrigger: MatMenuTrigger;
  @ViewChild('description') description: ElementRef;
  @ViewChild('tripTitle') public tripTitle: MatFieldComponent;
  // @ViewChild('tripMenu') public tripMenu: VisitorTripAddToTripMenuComponent;
  @ViewChild('details') detailsPanel: ElementRef;
  @ViewChild('itemImage') public itemImage: ImageComponent;
  @Output() onClosing: EventEmitter<any> = new EventEmitter();
  @Output() onPlaceFeedsClosing: EventEmitter<any> = new EventEmitter();
  @Output() onShown: EventEmitter<any> = new EventEmitter();
  @Output() onPlaceFeedsRetrieved: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    public imageService: ImageService,
    private formBuilder: FormBuilder,
    private visitorTripStore: VisitorTripStore,
    private allFrontendSettingsStore: AllFrontendSettingsStore,
    private notifyAddOrRemoveItemStore: VisitorTripNotifyAddOrRemoveItemStore,
    private visitorApiService: VisitorApiService,
    private activatedRoute: ActivatedRoute
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName, tripId } = this.allRouteParams;
    this.hubName = hubName;
    this.urlTripId = tripId;
    this.facebookLogo = this.imageService.imageSourceUrl(this.facebookLogo);

    if (tripId && tripId !== 'tour-list') {
      this.visitorApiService.getUserTripByTripID(this.hubName, tripId).subscribe((trip) => {
        this.urlTripFromUserID = trip ? trip.userFacebookId : null;
      });
    }

    this.allFrontendSettingsStore.allFrontendSettingsCommand
      .takeUntil(this.isDestroyed)
      .subscribe((command: AllFrontendSettingsCommand) => {
        if (command.toggle) {
          this.featuresToggle = command.toggle;
        }
      });
  }

  public get isShowAddtoMyTrip() {
    return this.showAddToTrip && !this.item['isOnlineEvent'];
  }

  public get isShowViewFBPostBtn() {
    return (
      !this.isFeedLoaded && this.type === 'place' && this.item.hostLink && this.item.hostLink.indexOf('facebook') >= 0
    );
  }

  public showNearByPlaces() {
    this.isShowNearbyPlaces = true;
  }

  public gotoPlace(item) {
    // this.data = new TripDetailModalData(item, 'place', this.hubName, null, null, false, null);
    //
    // setTimeout(() => {
    //     this.imgComp && this.imgComp.updateImage(this.data.item.cover && this.data.item.cover.source);
    //     this.imgViewer && this.imgViewer.updateImage(this.data.item.cover && this.data.item.cover.source);
    //     this.setGooglePlaceInfoAndFBPosts();
    // });
    this.showDetails({ item, feedType: 'place' }, '100%', '0');
  }

  public showFBPostsForMobile() {
    this.isShowFeedForMobile = true;
  }

  public showDetails(item: any, left, top, height?) {
    // if (!this.isDraggable || this.isMobile) {
    //     return;
    // }
    this.isFeedLoaded = false;
    this.canShowGoogleReviews = false;
    this.isShowNearbyPlaces = false;

    if (this.isShowDetail && this.item === item.item) {
      this.closeDetails();
      return;
    }

    if (item.feedType === 'event') {
      this.isMultiDateEvent = item.item.eventTimes && item.item.eventTimes.length > 1;

      if (item.item.startTimeText) {
        this.detailDate = EventTimeService.getDateFromTimeText(item.item.startTimeText);
        this.detailTime = EventTimeService.getTimeFromTimeText(item.item.startTimeText);

        if (this.isMultiDateEvent) {
          this.detailDate =
            EventTimeService.getDateFromTimeText(item.item.startTimeText) +
            ' - ' +
            EventTimeService.getDateFromTimeText(item.item.endTimeText);
        }
      } else if (item.item.startTime) {
        this.detailDate = EventTimeService.getDateFromTime(item.item.startTime);
        this.detailTime = EventTimeService.getTimeFromTime(item.item.startTime);

        if (this.isMultiDateEvent) {
          this.detailDate =
            EventTimeService.getDateFromTime(item.item.startTime) +
            ' - ' +
            EventTimeService.getDateFromTime(item.item.endTime);
        }
      } else {
        this.detailDate = null;
        this.detailTime = null;
      }

      if (item.item.eventTimes && item.item.eventTimes.length > 3) {
        this.trancatedEventTimes = item.item.eventTimes.slice(0, 3);
      } else if (item.item.eventTimes && item.item.eventTimes.length <= 3) {
        this.trancatedEventTimes = item.item.eventTimes.slice(0, item.item.eventTimes.length);
      }
      if (item.item.eventTimesText && item.item.eventTimesText.length > 3) {
        this.trancatedEventTimesText = item.item.eventTimesText.slice(0, 3);
      } else if (item.item.eventTimesText && item.item.eventTimesText.length <= 3) {
        this.trancatedEventTimesText = item.item.eventTimesText.slice(0, item.item.eventTimes.length);
      }
    }

    item.item.description && this.setDescription(item.item.description);

    this.item = item.item;
    this.type = item.feedType;
    this.isShowDetail = true;

    setTimeout(() => {
      this.detailsPanel.nativeElement.style.top = top;
      this.detailsPanel.nativeElement.style.left = left; //'calc(25% - 8px)';
      this.detailsPanel.nativeElement.style.opacity = 1;
      this.detailsPanel.nativeElement.style.transition = '0.6s';
      if (height) {
        this.detailsPanel.nativeElement.style.height = height;
      }

      this.placeFeeds = [];
      this.placeFeedPaging = null;
      if (item.feedType === 'place') {
        this.setGooglePlaceInfoAndFBPosts();
      }

      this.itemImage.updateImage(this.item.cover ? this.item.cover.source : null);

      setTimeout(() => {
        if (this.detailsPanel) {
          this.detailsPanel.nativeElement.style.transition = 'none';
        }
      }, 600);
    });
    this.onShown.emit({ item: item.item, type: item.feedType });
  }

  private async setGooglePlaceInfoAndFBPosts() {
    if (this.item.socialName === 'google') {
      this.googleInfo = await PlaceService.getGooglePlaceDetails(this.item, this.hubName, this.visitorApiService);

      if (this.googleInfo) {
        this.item.website = this.googleInfo.website;
        this.item.phone = this.googleInfo.formatted_phone_number || this.googleInfo.phone;
        if (
          ((this.googleInfo.reviews && this.googleInfo.reviews.length) ||
            (this.googleInfo.googleReviews && this.googleInfo.googleReviews.length)) &&
          this.featuresToggle.googleReviews
        ) {
          this.isFeedLoaded = true;

          // google reviews panel has an animation showing, so wait for a while to display the content
          setTimeout(() => {
            this.canShowGoogleReviews = true;
          }, 700);
        }
      }

      if (this.featuresToggle.facebookPosts) {
        let matched = await PlaceService.matchToFacebookPlace(this.item, this.hubName, this.visitorApiService);

        if (matched.fbId) {
          this.getFacebookPlaceFeed(matched.fbId);
          this.setDescription(matched.place.description || matched.place.about);
        }
      }
    } else {
      this.getFacebookPlaceFeed();
    }
  }

  public closeFeeds() {
    if (!this.isFeedLoaded) {
      this.closeDetails();
      return;
    }
    this.isFeedLoaded = false;

    this.onPlaceFeedsClosing.emit();

    this.placeFeeds = [];

    this.closeDetails();
  }

  public closeDetails() {
    if (!this.detailsPanel) {
      return;
    }
    if (this.isMobile && this.isShowFeedForMobile) {
      this.isShowFeedForMobile = false;
      this.setDescription(this.item.description);
      return;
    }
    this.detailsPanel.nativeElement.style.transition = '0.6s';
    this.detailsPanel.nativeElement.style.left = '75%';
    this.detailsPanel.nativeElement.style.opacity = 0;
    this.onClosing.emit();

    setTimeout(() => {
      if (this.detailsPanel) {
        this.detailsPanel.nativeElement.style.transition = 'none';
      }
    }, 600);
    setTimeout(() => {
      this.isShowDetail = false;
    }, 1000);
  }

  public showMoreTimes() {
    if (this.trancatedEventTimes.length === 3) {
      this.trancatedEventTimes = this.item.eventTimes;
      if (this.item.eventTimesText) {
        this.trancatedEventTimesText = this.item.eventTimesText;
      }
    } else {
      this.trancatedEventTimes = this.item.eventTimes.slice(0, 3);

      if (this.item.eventTimesText && this.item.eventTimesText.length > 3) {
        this.trancatedEventTimesText = this.item.eventTimesText.slice(0, 3);
      }
    }
  }

  public showOnMap($event?) {
    $event && $event.stopPropagation();
    this.closeDetails();
    this.visitorTripStore.tripCommand.next(new VisitorTripCommand(this.item));
  }

  private setDescription(description) {
    if (description) {
      setTimeout(() => {
        if (this.description) {
          this.description.nativeElement.innerHTML = description;
        }
      }, 100);
    } else {
      setTimeout(() => {
        if (this.description) {
          this.description.nativeElement.innerHTML = '';
        }
      }, 100);
    }
  }

  public getFacebookPlaceFeed(id?) {
    // id = id ? id : ShareService.getFacebookPlaceId(this.item.hostLink);

    // if (
    //   id &&
    //   ((this.item.socialName === 'facebook' && FacebookLoginButtonComponent.isUserLoggedWithFacebook) ||
    //     (this.item.socialName === 'google' && this.featuresToggle.facebookPosts))
    // ) {
    //   let url = config.facebook.graphApi.placePosts
    //     .replace('${accessToken}', config.facebook.approvedApps[0])
    //     // .replace('${accessToken}', FacebookLoginButtonComponent.userAccessToken)
    //     .replace('${placeId}', id);
    //   FB.api(url, (response) => {
    //     this.placeFeedPaging = response.paging;

    //     if (!!response.error) {
    //       //console.error(response.error);
    //       this.placeFeedPaging = null;
    //       return;
    //     }
    //     this.updatePlaceFeeds(response.data);
    //   });
    // }
  }

  public getNextFacebookPlaceFeed(event: ButtonTriggerEvent) {
    FB.api(this.placeFeedPaging.next, (response) => {
      event.complete();
      this.placeFeedPaging = response.paging;

      if (!!response.error) {
        console.error(response.error);
        return;
      }

      this.updatePlaceFeeds(this.placeFeeds.concat(response.data));
    });
  }

  private updatePlaceFeeds(placeFeeds) {
    // this.placeFeeds = placeFeeds.filter(x => x.message && x.from && x.actions && x.actions.length >= 2);
    this.placeFeeds = placeFeeds.filter((x) => x.message);
    this.placeFeeds.forEach((x) => {
      x.from.link = config.facebook.graphApi.profile.replace('${userId}', x.from.id);
      x.from.picture = config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
    });
    if (this.placeFeeds && this.placeFeeds.length) {
      this.onPlaceFeedsRetrieved.emit({ item: this.item });
    }
    //setTimeout(() => {
    if (this.placeFeeds && this.placeFeeds.length) {
      this.isFeedLoaded = true;
    }
    //});
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/trip.float.detail/trip.float.detail.component.ts